import { render, staticRenderFns } from "./HeaderChart.vue?vue&type=template&id=37dd8f38&scoped=true&"
import script from "./HeaderChart.vue?vue&type=script&lang=js&"
export * from "./HeaderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd8f38",
  null
  
)

export default component.exports